export const ORDER_OVERVIEW_LIST_FAIL =
  'order-overview/ORDER_OVERVIEW_LIST_FAIL';
export const ORDER_OVERVIEW_LIST_REQUEST =
  'order-overview/ORDER_OVERVIEW_LIST_REQUEST';
export const ORDER_OVERVIEW_LIST_SUCCESS =
  'order-overview/ORDER_OVERVIEW_LIST_SUCCESS';
